import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const StormIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M3.44042 10.3823C3.28377 10.5981 3.20783 10.8383 3.1991 11.0749C1.91028 10.5414 1 9.23872 1 7.7164C1 5.85115 2.36658 4.31571 4.12162 4.12076C4.55776 2.32759 6.12884 1 8 1C10.1422 1 11.8911 2.74003 11.9951 4.92688L12 5.13317C13.6569 5.13317 15 6.52103 15 8.23305C15 9.94506 13.6569 11.3329 12 11.3329H11.4122C12.0992 10.5462 11.5641 9.26634 10.5176 9.26634H9.86894L10.6252 8.09421C11.1568 7.2702 10.5852 6.16646 9.62672 6.16646H7.25042C6.77828 6.16646 6.3337 6.39615 6.05042 6.78644L3.44042 10.3823Z"
		></path>
		<path
			fill="currentColor"
			d="M6.74343 11.3329H4.40042C4.23561 11.3329 4.1407 11.1385 4.23958 11.0023L6.84958 7.40641C6.94401 7.27632 7.0922 7.19975 7.24958 7.19975H9.62588C9.78562 7.19975 9.88173 7.38371 9.79313 7.52104L8.00042 10.2996H10.5167C10.6949 10.2996 10.785 10.5222 10.659 10.6524L6.51016 14.9385C6.36672 15.0867 6.12551 14.9456 6.17471 14.7423L6.93746 11.5897C6.96901 11.4593 6.87354 11.3329 6.74343 11.3329Z"
		></path>
	</svg>
))
